import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BlogPostLinkProps {
  to: string;
  children: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const BlogPostLink = ({ to, children, className, onClick }: BlogPostLinkProps) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={className}
    >
      {children}
    </Link>
  );
};

export default BlogPostLink;
